import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { provide, watch, ref } from "vue";
//import types
import type { NavBarProps } from "@/typings";
//import injection symbols
import { deactivateNavSymbol } from "@/injection";
//import composables
import { useToggle, useMProp, useProp } from "@toolsie/composables";
import useIsResponsible from "@/composables/useIsResponsive";
//import and define props
import { navContainerProps as propsObject } from "@/props";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "NavBar",
  inheritAttrs: true,
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: propsObject,
  emits: ["update:active", "update:responsive"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "update:active", value: boolean): void;
  (e: "update:responsive", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props: NavBarProps = __props;

//import vue


//define the emits


//get the active value as a modifiable prop
let active = useMProp(props, "active", false, emits, "update:active");
//get the toggler for the isActive value
let { toggle: toggleMenu } = useToggle(active);

//provide the deactivation flag and watch it
/** @const deactivateMenuFlag */
const deactivateNavFlag = ref(false);
//provide the flag with the symbol
provide(deactivateNavSymbol, deactivateNavFlag);

//watch the flag to toggle the menu in case it changes
watch(deactivateNavFlag, () => toggleMenu(false));

let breakpoint = useProp(props, "breakpoint", 0);

const isResponsive = useIsResponsible(breakpoint, emits);
//get if the menu is fixed

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(["toolsie nav bar", {
      active: _unref(active),
      inactive: !_unref(active),
      responsive: _unref(isResponsive),
      fixed: _ctx.fixed,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default", { deactivateMenu: _unref(toggleMenu) }),
    _withDirectives(_createElementVNode("p", {
      href: "javascript:void(0);",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleMenu)())),
      class: _normalizeClass(["toggle", {
        left: _ctx.leftToggle,
        right: !_ctx.leftToggle,
      }])
    }, " ☰ ", 2), [
      [_vShow, _unref(isResponsive)]
    ])
  ], 2))
}
}

})